import { PublicClientApplication } from "@azure/msal-browser";
import { authConfig } from "../features/Authentification/authProvider";

const loginRequest = {
  scopes: [`${process.env.REACT_APP_API_MANAGEMENT_SCOPE}`],
};

export const msalInstance = new PublicClientApplication(authConfig);

export async function getAccessToken() {
  await msalInstance.initialize();
  const account = msalInstance.getAllAccounts()[0];
  if (!account) {
    throw new Error("No active account! User may need to log in.");
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return response.accessToken;
  } catch (error) {
    console.warn(
      "Silent token acquisition failed, redirecting to login.",
      error,
    );
    await msalInstance.acquireTokenRedirect(loginRequest);
  }
}

export async function getAuthHeader() {
  let apiToken = await getAccessToken();
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${apiToken}`,
  };
}
